import { colors, mediaQueries, size } from '@everlywell/leaves';
import { Link } from 'gatsby';
import styled, { createGlobalStyle } from 'styled-components';

const Layout = styled.div.attrs((props) => ({
  fadeIn: props.fadeIn,
}))`
  display: flex;
  flex-direction: column;
  margin-top: ${size.xl4}px;

  ${mediaQueries.forTabletHorizontalUp} {
    margin-top: ${size.xl4 - 6}px;
  }

  *:focus {
    outline-color: ${colors.teal4};
  }
`;

const CheckoutLayout = styled.div`
  background: ${colors.white};

  ${mediaQueries.forTabletHorizontalUp} {
    background: ${colors.green1};
  }
`;

export const SolvvyOverrideStyles = createGlobalStyle`
  #solvvy-v5-widget-container .solvvy-v5-widget {
    opacity: 1 !important;
    pointer-events: initial;
  }
`;
export const SolvvyHiddenStyles = createGlobalStyle`
  #solvvy-v5-widget-container .solvvy-v5-widget {
    opacity: 0 !important;
    pointer-events: none;
  }
`;

export const SkipLink = styled.a`
  position: fixed;
  display: block;
  z-index: -1;
  top: -10000px;
  opacity: 0;
  left: 50%;
  transform: translateX(-50%);
  background-color: ${colors.green4};
  box-shadow: 0 2px 15px -5px rgb(0 0 0 / 75%);
  color: ${colors.white};
  text-decoration: none;
  padding: ${size.sm}px ${size.lg}px;

  &:hover {
    background-color: ${colors.teal6};
  }

  &:focus {
    top: 5px;
    opacity: 1;
    z-index: 3;
    transition: opacity 0.1s ease-in;
  }
`;

export const CartSkeletonWrapper = styled.div`
  display: flex;
  margin-left: ${size.xs1}px;
`;

export const HeaderLinkWrapper = styled(Link)`
  position: relative;

  &:active {
    color: ${colors.green3};
    top: 1px;
  }
`;

export { Layout, CheckoutLayout };
